import { render, staticRenderFns } from "./fulltext-search.html?vue&type=template&id=3d24a58e&scoped=true&"
import script from "./fulltext-search.js?vue&type=script&lang=js&"
export * from "./fulltext-search.js?vue&type=script&lang=js&"
import style0 from "./fulltext-search.scss?vue&type=style&index=0&id=3d24a58e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24a58e",
  null
  
)

export default component.exports